import { useEffect } from "react";
import { fetchUserSubscriptions, getToken } from "./authHelper";

export const fetchUserData = async (setLoading, setUserProfile, setError) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = getToken();

  try {
    setLoading(true);
    if (!apiUrl || !token) {
      throw new Error("Missing auth token");
    }

    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();

    if (!response.ok || !data?.results) {
      throw new Error("Unable to fetch current user");
    }

    setUserProfile(data.results);
  } catch (error) {
    console.error("Error fetching user data:", error);
    setError(true);
  } finally {
    setLoading(false);
  }
};


// Function to manage inactivity and session checks
export const useInactivityTimer = (enabled = true) => {
    useEffect(() => {
      if (!enabled) {
        return undefined;
      }

      let inactivityTimer;
      let checkAuthTimer;
  
      const resetTimers = () => {
        clearTimeout(inactivityTimer);
        clearTimeout(checkAuthTimer);
  
        inactivityTimer = setTimeout(() => {
          checkAuthTimer = setTimeout(() => {
            window.addEventListener("mousemove", checkAuthOnActivity);
            window.addEventListener("keydown", checkAuthOnActivity);
          }, 0);
        }, 3600000); // 1 hour
      };
  
      const checkAuthOnActivity = async () => {
        window.removeEventListener("mousemove", checkAuthOnActivity);
        window.removeEventListener("keydown", checkAuthOnActivity);
  
        try {
          await checkCurrentSession();
          resetTimers();
        } catch {
          redirectTo("/logout");
        }
      };
  
      resetTimers();
      window.addEventListener("mousemove", resetTimers);
      window.addEventListener("keydown", resetTimers);
  
      return () => {
        clearTimeout(inactivityTimer);
        clearTimeout(checkAuthTimer);
        window.removeEventListener("mousemove", resetTimers);
        window.removeEventListener("keydown", resetTimers);
      };
    }, [enabled]);
  };
  
  // Function to fetch subscriptions
export const useFetchSubscriptions = (
  setSubscriptions,
  setSubscriptionLoading,
  enabled = true,
) => {
    useEffect(() => {
      if (!enabled) {
        setSubscriptions(null);
        setSubscriptionLoading(false);
        return;
      }

      fetchUserSubscriptions(setSubscriptions,setSubscriptionLoading);
    }, [enabled, setSubscriptionLoading, setSubscriptions]);
  };


export const checkCurrentSession = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(`${apiUrl}/auth:current`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
  
    if (!response.ok) {
      throw new Error("Session expired");
    }
  };
  
  export const redirectTo = (url) => {
    window.location.href = url;
  };


export const handleAddAccountId= async (account_id,setStatus,setError, setIsLoading) => {
    setIsLoading(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(`${apiUrl}/auth/add_account_id?account_id=${account_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },

      });
  
      if (response.ok) {
        setStatus(true)
      } else {
        setStatus(false)
        setError(true)
      }
    } catch (error) {
      console.error("Error adding Account ID:", error);
      setError(true)
    }
    finally{
      setIsLoading(false);
    }
  };
